export default Object.freeze({
	WEB: 'web',
	CSV: 'csv'
});